<div class="full-width page-content page-padding" fxLayout="column">
  <div fxLayout="row" fxFlexOffset="20px">
    <span class="subtitle-default">Billing Details</span>
  </div>

  <div class="full-width" fxLayout="row" fxLayoutGap="20px" fxFlexOffset="30px" *ngIf="billingDetails">
    <div class="info-card" fxLayout="column">
      <div class="fx-row fx-gap-20">
        <span class="heading-default">Company Billing Details</span>
        <div class="fx-row fx-gap-10">
          <button class="button-action" mat-flat-button (click)="editBillingDetails(true)"
                  *ngIf="!editingBillingDetails"
                  [disabled]="editingBankingDetails || (loading$ | async)">
            <div class="button-text">Update</div>
          </button>

          <button class="button-action-cancel" mat-flat-button
                  (click)="editBillingDetails(false)"
                  *ngIf="editingBillingDetails"
                  [disabled]="(loading$ | async)">
            <div class="button-text">Cancel</div>
          </button>

          <button class="button-action" mat-flat-button
                  (click)="updateBillingDetails()"
                  *ngIf="editingBillingDetails"
                  [disabled]="(loading$ | async)">
            <div class="button-text">Save</div>
          </button>


        </div>
      </div>

      <div fxLayout="column" fxLayoutGap="15px" fxFlexOffset="20px">

        <mat-form-field class="custom-text-autofill" [class.custom-text-field]="editingBillingDetails"
                        appearance="outline" style="max-width: none;" floatLabel="always">
          <mat-label>Company Name</mat-label>
          <input matInput type="text" [value]="utils.displayString(billingDetails.billingName, 50)"
                 [(ngModel)]="billingDetails.billingName"
                 [disabled]="!editingBillingDetails">
        </mat-form-field>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" [class.custom-text-field]="editingBillingDetails"
                            appearance="outline" floatLabel="always">
              <mat-label>Company Registration Number</mat-label>
              <input matInput type="text" [value]="utils.displayString(billingDetails.compReg, 50)"
                     [(ngModel)]="billingDetails.compReg"
                     [disabled]="!editingBillingDetails">
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" [class.custom-text-field]="editingBillingDetails"
                            appearance="outline" floatLabel="always">
              <mat-label>VAT Registration Number</mat-label>
              <input matInput type="text" [value]="utils.displayString(billingDetails.vatReg, 50)"
                     [(ngModel)]="billingDetails.vatReg"
                     [disabled]="!editingBillingDetails">
            </mat-form-field>
          </div>
        </div>

        <!--        location-->

        <mat-form-field class="custom-text-autofill full-width" appearance="outline" style="max-width: none;"
                        *ngIf="!editingBillingDetails" floatLabel="always">
          <mat-label>Billing Address</mat-label>
          <input matInput type="text" [value]="utils.displayString(billingDetails.formattedAddress, 80)" [disabled]="!editingBillingDetails">
        </mat-form-field>

        <mat-form-field class="custom-text-field-full-width" appearance="outline" *ngIf="editingBillingDetails" floatLabel="always"
                        hideRequiredMarker>
          <mat-label>Billing address</mat-label>
          <input
            (onAutocompleteSelected)="onAddressAutocompleteSelected($event)"
            (onLocationSelected)="onAddressLocationSelected($event)"
            [value]="billingDetails.formattedAddress!"
            matGoogleMapsAutocomplete
            matInput
          />
        </mat-form-field>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" [class.custom-text-field]="editingBillingDetails"
                            appearance="outline" floatLabel="always">
              <mat-label>Email</mat-label>
              <input matInput type="email" [value]="utils.displayString(billingDetails.billingEmail, 50)"
                     [(ngModel)]="billingDetails.billingEmail"
                     [disabled]="!editingBillingDetails">
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" [class.custom-text-field]="editingBillingDetails"
                            appearance="outline" floatLabel="always">
              <mat-label>Phone Number</mat-label>
              <input matInput type="tel" [value]="utils.displayString(billingDetails.phoneNum, 50)"
                     [(ngModel)]="billingDetails.phoneNum"
                     [disabled]="!editingBillingDetails">
            </mat-form-field>
          </div>
        </div>

      </div>
    </div>

    <!--    BANKING-->

    <div class="info-card" fxLayout="column">

      <div class="fx-row fx-gap-20">
        <span class="heading-default">Company Banking Details</span>
        <div class="fx-row fx-gap-10">
          <button class="button-action" mat-flat-button
                  (click)="updateBankingDetails()"
                  [disabled]="confirmRemove || editingBillingDetails || (loading$ | async)">
            <div class="button-text">Update</div>
          </button>

          <button class="button-action" mat-flat-button *ngIf="bankingDetails && bankingDetails.length > 0"
                  (click)="confirmRemove = true"
                  [disabled]="confirmRemove || editingBillingDetails || editingBankingDetails ||(loading$ | async)">
            <div class="button-text">Remove</div>
          </button>
        </div>

        <app-confirm-remove message="Are you sure you want to remove this retailer's payment method details?"
                            (confirmRemove)="removeBankingDetails()"
                            *ngIf="confirmRemove">
        </app-confirm-remove>
      </div>

      <div fxLayout="column" fxLayoutGap="15px" fxFlexOffset="20px" *ngFor="let details of bankingDetails">

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Payment Method Type</mat-label>
              <input matInput type="text" [value]="utils.displayStatus(details.paymentMethodTypeCode!)" disabled>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Account Reference</mat-label>
              <input matInput type="text" [value]="utils.displayUuid(details.bankAccountReference!)" disabled>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Updated By</mat-label>
              <input matInput type="text" [value]="details.updateUserName" disabled>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Update Date</mat-label>
              <input matInput type="text" [value]="dateUtils.displayDateWithTime(details.updateDate!)" disabled>
            </mat-form-field>
          </div>
        </div>

      </div>

      <div fxLayout="column" fxLayoutGap="15px" fxFlexOffset="20px" *ngIf="bankingDetails.length == 0">

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Payment Method Type</mat-label>
              <input matInput type="text" disabled>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Account Reference</mat-label>
              <input matInput type="text" disabled>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Updated By</mat-label>
              <input matInput type="text" disabled>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Update Date</mat-label>
              <input matInput type="text" disabled>
            </mat-form-field>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>
